import { Skeleton } from '@mui/material';
import { FC } from 'react';

const StatisticsItemSkeleton: FC = () => {
  return (
    <div>
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
      <Skeleton animation="wave" variant="text" />
    </div>
  );
};

export default StatisticsItemSkeleton;
